import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '@ohpen/enso-ui';

import { RolesList } from '@config/components';

export const RolesPage = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <Page>
      <Page.Title>{t('config.sections.roles')}</Page.Title>
      <Page.Content fill>
        <RolesList />
      </Page.Content>
    </Page>
  );
};
